import addSubscriptionDialogCtrl from "./addSubscriptionDialog/addSubscriptionDialog.controller";
import addSubscriptionDialogTmpl from "./addSubscriptionDialog/addSubscriptionDialog.html";

class Controller {
  constructor($injector, $stateParams, $state, $mdDialog, Sections) {
    "ngInject";

    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.sections = Sections.customersSections;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Reservation = $injector.get("Reservation");
    this.ActionLists = $injector.get("ActionLists");
    this.Subscription = $injector.get("Subscription");
    this.CorporateTransforms = $injector.get("CorporateTransforms");
    this.ReservationTransforms = $injector.get("ReservationTransforms");
    this.scheduleResourceActions = this.ActionLists.all.corporateActions;
    this.subscriptionFields = this.CorporateTransforms.subscriptionFields;
    this.onUpdateReservationPriceEvent = this.Events.getUpdateEvent(
      "reservationPrice"
    );
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    const get = () => {
      this.Reservation.get(this.$stateParams.id).$promise.then((response) => {
        this.reservation = this.ReservationTransforms.justify(response);
        this.scheduleParams = {
          schedule: this.reservation.schedule._id,
          corporate: this.reservation.corporate._id,
          isCityRequired: false,
        };
      });
    };

    get();

    this.addSubscription = (schedule) => {
      const routeId = this.reservation.route._id;
      const addSubs = this.$mdDialog.show({
        controller: addSubscriptionDialogCtrl,
        controllerAs: "$ctrl",
        template: addSubscriptionDialogTmpl,
        locals: { schedule, routeId },
      });

      addSubs.then(
        (obj) => {
          obj.corporate_reservation = this.reservation._id;
          this.Subscription.post(obj).$promise.then(
            () => {
              this.$state.reload();
              this.Events.emit(
                this.showNotificationEvent,
                this.Messages.addMessage("subscription")
              );
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.removeReservation = () => {
      this.Reservation.delete(this.$stateParams.id).$promise.then(
        () => {
          this.$state.transitionTo("corporate", {
            id: this.reservation.corporate._id,
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation.controller.js